jQuery_T4NT(document).ready(function ($) {
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */

  $("body").on("click", "#notify_button", function (e) {
    var pid = parseInt($(this).data("pid"));
    var email = $("#notify_email").val();
    var vid = parseInt($(".t4s-product__select.opt-select").val());
    if (email != "") {
      $.ajax({
        type: "POST",
        url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
        data: {
          a: "VZUKhS",
          email: email,
          variant: vid,
          platform: "shopify",
        },
        success: function (response) {
          console.log(response);
        },
        error: function (response) {
          console.log(response);
        },
      });
                $(".notify-main").hide();
          $(".thank-msg").show();

    }
  });
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
    var pid = evt.currentVariant.featured_image.product_id;
    console.log(evt.currentVariant);
    var cvariant = evt.currentVariant;
    var coptions = cvariant.options.length;
    if (cvariant.available == true) {
      $(".notify-main[data-pid=" + pid + "]").hide();
    } else {
      $(".notify-main[data-pid=" + pid + "]").show();
    }
  });
  $(".accordian-mobile").click(function (e) {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(".review-container").removeClass("active");
    } else {
      $(this).addClass("active");
      $(".review-container").addClass("active");
    }
  });
  $(".custom-add-on").change(function (e) {
    var cval = 0;
    var ori = parseInt($(this).val());
    var v = $(this).data("product-id");
    console.log("hii", $(this));
    var options = $(this).find("option");
    console.log(options);
    $(options).each(function () {
      cval = parseInt($(this).val());
      if (cval == ori) {
        var img = $(this).data("v-image");
        var price = $(this).data("price");
        var cprice = $(this).data("compare-price");
        $(".add-on-image-" + v).attr("src", img);
        $(".price-add-sale-" + v).html(price);
        $(".price-add-compare-" + v).html(cprice);
      }
    });
  });
  $("[data-swatch-item-addon]").click(function () {
    let sib = $(this).siblings();
    $(sib).each(function () {
      $(this).removeClass("is--selected");
    });
    $(this).addClass("is--selected");
    var cval = 0;
    var ori = $(this).data("value");
    var v = $(this).data("prd-id");
    console.log(v);
    var options = $(".custom-addon-" + v).find("option");
    console.log(options);
    $(options).each(function () {
      $(this).attr("selected", false);
      cval = $(this).data("variant");
      if (ori.indexOf(cval) != -1) {
        $(this).attr("selected", true);
        var img = $(this).data("v-image");
        var price = $(this).data("price");
        var cprice = $(this).data("compare-price");
        $(".add-on-image-" + v).attr("src", img);
        $(".price-add-sale-" + v).html(price);
        $(".price-add-compare-" + v).html(cprice);
      }
    });
  });
});
